<template>
    <div class="container mb-5" >
        <h6 class="text-secondary text-center my-3">
            فروشگاه {{item.supplier}}
        </h6>
        <div class="d-flex mx-auto justify-content-between rounded bg-light p-2">
            <div class="d-flex flex-column justify-content-between w-75">
                <p style="color:#303030; font-size: 14px" class="mb-4">
                    {{item.user}}
                </p>
                <p>
                    {{item.address}}
                </p>
            </div>
            
            <div class="d-flex flex-column justify-content-between w-25">
                <p style="color:#8f8f8f; font-size: 14px;" class="text-end mb-4">
                    کد پیگیری : {{convertToPersian(item.log_id)}}
                </p>
                <p class="text-end">
                    {{item.date}}
                </p>
            </div>
        </div>
        <div class="card mb-4 mt-4">
                <div class="card-body overflow-auto">
                    <table class="table table-bordered table-striped">
                        <thead>
                            <tr>
                                <th scope="col" style="width:5px">ردیف</th>
                                <th scope="col" style="width: max-content;">محصول</th>
                                <th scope="col">قیمت</th>
                                <th scope="col">تخفیف</th>
                                <th scope="col">تعداد</th>
                                <th scope="col">قیمت نهایی</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="tr,index in item.items" :key="tr.id">
                                <td>{{convertToPersian(String(index +1))}}</td>
                                <td class="d-flex" >
                                    <img :src="'https://radap.ir/'+tr.img" width="50" height="50" style="max-width: initial;"/>
                                    <div class="d-flex flex-column ms-2" style="min-width:125px">
                                        <span>{{tr.name}}</span>
                                        <small class="text-muted">{{tr.description}}</small>
                                    </div>
                                </td>
                                <td>{{convertToPersian(String(numberFormat(tr.price)))}}</td>
                                <td><span v-if="tr.discount > 0">%</span>{{convertToPersian(tr.discount || 0)}}</td>
                                <td>{{convertToPersian(String(numberFormat(tr.num)))}}</td>
                                <td>{{convertToPersian(String(numberFormat((tr.price - ((tr.price * (tr.discount || 0) )/100) * tr.num))))}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        
    <div>آدرس : </div>
        <div>{{ item.address }}</div>
        <hr />
        <div class="d-flex justify-content-between">
            <div>جمع صورتحساب :</div>
            <div>{{ convertToPersian(numberFormat(Number(item.item_cost) + Number(item.discount))) }} تومان</div>
        </div>
        <div class="d-flex justify-content-between"  v-if="item.discount > 0">
            <div>سود شما : </div>
            <div>{{ convertToPersian(numberFormat(item.discount)) }} تومان</div>
        </div>
        <div class="d-flex justify-content-between">
            <div>هزینه ارسال : </div>
            <div>رایگان</div>
        </div>
        <div class="d-flex justify-content-between" v-if="item.wallet > 0">
            <div>کیف پول :</div>
            <div>{{ convertToPersian(numberFormat(item.wallet)) }} تومان</div>
        </div>
        <div class="d-flex justify-content-between">
            <div>مبلغ نهایی : </div>
            <div class="text-success">{{ convertToPersian(numberFormat(item.amount)) }} تومان</div>
        </div>
        <p style="color: #909090; font-size:12px; text-align:center;" class="mt-1">خریدی امن و به صرفه از راداَپ <a href='https://radap.ir'>radap.ir </a></p>    
    </div>

</template>
    <script setup>
    import { reactive} from 'vue';
    import axios from 'axios';
    import { useRoute } from 'vue-router';
    import { numberFormat,convertToPersian,removeCommos } from '@/composables/digits';
    let Route = useRoute();
    // let itemFactor = ref()
    let item = reactive({
        id : '',
        log_id : '',
        order_id : '',
        user : '',
        supplier : '',
        address : '',
        day_time : '',
        item_cost : '',
        discount : '',
        delivery_cost : '',
        type_pay : '',
        amount : '',
        wallet : '',
        description : '',
        items : '',
        date : ''
    })
    let orderId = Route.params.id
    getOrder()
    function getOrder(){
    axios
    .get("https://radap.ir/Backend/api/account/order/factor.php?id="+orderId)
      .then((res) => {
        item.id = res.data.order_id
        item.order_id = res.data.order_id
        item.user = res.data.user
        item.supplier = res.data.supplier
        item.address = res.data.address
        item.day_time = res.data.day_time
        item.item_cost = res.data.item_cost
        item.discount = res.data.discount
        item.delivery_cost = res.data.delivery_cost
        item.type_pay = res.data.type_pay
        item.amount = res.data.amount
        item.date = res.data.date
        item.wallet = res.data.wallet
        item.description = res.data.description
        item.items = res.data.items
        item.log_id = res.data.log_code
      })
    }
 
</script>
    
<style scoped>
    *{
        font-family: 'Sahel';
    }
    p{
        margin-bottom: 0;
    }
</style>